import { getDisplayNameByKey, orderableItemValues } from "@sellar-io/common";
import { Icon, SpinnerLegacy } from "../../../../../components";
import { ProductTemplateType } from "@sellar-io/api-v2/types";
import { useProductTemplateList } from "../../../../../hooks/api/v2/productTemplate/useProductTemplateList";
import { InfiniteList } from "../../../../../components/infiniteLoading/InfiniteList";
import { Button } from "../../../../../../../components/lib/components/Button";

export const ProductTemplateList = ({
  launchProductCreate,
}: {
  launchProductCreate: (template?: ProductTemplateType) => void;
}) => {
  const productTemplatesQuery = useProductTemplateList({ limit: 20 });
  const productTemplates =
    productTemplatesQuery.data?.pages.flatMap((page) => page) ?? [];

  return (
    <div className="flex flex-col gap-4 border-t border-zinc-300 p-4">
      <div className="flex flex-col gap-1">
        <h3 className="font-semibold">Start with a template</h3>
        <p className="text-sm text-zinc-500">
          Optionally start with a format you've used for other products. Or
          choose Add other format for a new product type.
        </p>
      </div>
      {productTemplatesQuery.isPending ? (
        <SpinnerLegacy />
      ) : (
        <InfiniteList query={productTemplatesQuery}>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {productTemplates.map((template) => (
              <Button
                key={template.id}
                color="transparent"
                className="w-full justify-start border border-dotted border-zinc-300"
                onClick={() => launchProductCreate(template)}
              >
                <Icon icon="PLUS" size={1.1} className="shrink-0" />
                <span>
                  Add{" "}
                  {template.packQuantity > 1 && `${template.packQuantity}x `}
                  {template.volume}
                  {template.displayUnit}{" "}
                  {getDisplayNameByKey(
                    orderableItemValues,
                    template.containerType,
                  )}
                </span>
              </Button>
            ))}
            <Button
              color="transparent"
              className="w-full justify-start border border-dotted border-zinc-300"
              onClick={() => launchProductCreate()}
            >
              <Icon icon="PLUS" size={1.1} className="shrink-0" />
              Add other format
            </Button>
          </div>
        </InfiniteList>
      )}
    </div>
  );
};
